import * as React from 'react';

import classNames from 'classnames';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import safeHtmlId from 'js/lib/safeHtmlId';

import HorizontalLearnerPhotos from 'pages/open-course/peerReview/components/HorizontalLearnerPhotos';
import StackedLearnerPhotos from 'pages/open-course/peerReview/components/StackedLearnerPhotos';
import type { ReviewerDetails } from 'pages/open-course/peerReview/components/types';

import 'css!./__styles__/OptionFeedbackRow';

type Props = {
  checked: boolean;
  groupId: string;
  optionId: string;
  reviewers: ReviewerDetails[];
  isAssignmentLevelPart: boolean;
  isAIGraded?: boolean;
  children?: React.ReactNode;
};

const OptionFeedbackRow = (props: Props) => {
  const scopedGroupId = 'OptionFeedbackRow-' + safeHtmlId(props.groupId);
  const scopedOptionId = 'OptionFeedbackRow-' + safeHtmlId(props.groupId) + '-' + safeHtmlId(props.optionId);

  const checkColorClass = props.checked ? 'body-2-text' : 'body-1-text';
  const textColumnClasses = classNames('option-text-column', checkColorClass);
  return (
    <tr className="rc-OptionFeedbackRow">
      <td className="option-bubble-column">
        <input
          type="radio"
          disabled={true}
          checked={props.checked}
          name={scopedGroupId}
          aria-labelledby={scopedOptionId}
        />
      </td>
      <td id={scopedOptionId} className={textColumnClasses}>
        {props.children}
        {!props.isAIGraded && props.isAssignmentLevelPart && <HorizontalLearnerPhotos learners={props.reviewers} />}
      </td>
      {!props.isAIGraded && !props.isAssignmentLevelPart && (
        <td className="option-reviewers-column">
          <StackedLearnerPhotos learners={props.reviewers} />
        </td>
      )}
    </tr>
  );
};

export default OptionFeedbackRow;
